import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import EditPopup from '../../components/Popup/EditPopup/EditPopup'; 
import AddPopup from '../../components/Popup/AddPopup/AddPopup';
import ArchivePopup from '../../components/Popup/ArchivePopup/ArchivePopup';
import EditIcon from '../../components/Table/EditIcon/EditIcon';
import Filter from '../../components/common/Filter/Filter';
import ArchiveIcon from '../../components/Table/ArchiveIcon/ArchiveIcon';
import ExportLabel from '../../components/common/ExportLabel/Export';
import AddButton from '../../components/common/AddButton/AddButton';
import SimpleSearchBox from '../../components/common/Search/SimpleSearch';
import Sort from '../../components/common/Sort/Sort';
import '../../components/common/SubNavbar.css';
import '../../components/common/CommonText.css';
import '../../components/common/Table.css';
import './countries.css';
import { baseurl } from '../../api';
import DetailPopup from '../../components/Popup/DetailPopup/DetailPopup';
import { isTextOnly,isRequired, isValidCountryCode } from '../../validation';
import { useCheckboxClick } from '../../checkboxclick';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import authenticatedAxios from '../../authenticatedAxios';
import useFilterStore from '../../store/useFilterStore';
import DeleteIcon from '../../components/Table/DeleteIcon/DeleteIcon';
import DeletePopup from '../../components/Popup/DeletePopup/DeletePopup';
import useRefreshStore from '../../store/useRefreshStore';
const pageKey = "country"

const Countries = () => {
  const { setFilters, getFilters } = useFilterStore();
  const savedFilters = getFilters(pageKey);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [isNewPopupOpen, setIsNewPopupOpen] = useState(false);
  const [isDetailPopupOpen, setIsDetailPopupOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [items, setItems] = useState([]);
  const [timezoneOptions, setTimezoneOptions] = useState([]);
  const [plans, setPlans] = useState([]);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false)
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [activePlanOptions, setActivePlanOptions] = useState([]);
  const sortOptions = ["A-Z", "Z-A", "Newest", "Oldest"];
  const filterOptions = ["Default", "Archived", "Unarchived"];
  const [searchParams, setSearchParams] = useState(savedFilters?.searchParams || { term: "" });
  const [selectedFilterOption, setSelectedFilterOption] = useState(savedFilters?.selectedFilterOption || "Unarchived");
  const [selectedSortOption, setSelectedSortOption] = useState(savedFilters?.selectedSortOption || "Newest");
  const [popupError, setPopupError] = useState('');
  const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(items);
  const navigate = useNavigate();
  const { refreshKeys } = useRefreshStore();
  const refreshKey = refreshKeys["Countries"] || 0;

  const fetchCountries = async (id = null) => {
    try {
      if (id) {
        const response = await authenticatedAxios.get(`${baseurl}localization/country/?id=${id}`);
        if (response && response.data) {
          setSelectedItem(response.data.data);
          setIsEditPopupOpen(true);
        } else {
          console.error("No data found for the selected country.");
        }
      } else {
        const params = {
          search: searchParams.term,
          filter: selectedFilterOption === "Default" ? undefined : selectedFilterOption.toLowerCase(),
          sort: mapSortOptionToQuery(selectedSortOption),
        };
  
        const response = await authenticatedAxios.get(`${baseurl}localization/country/`, { params });
        if (response.data.response_code === 1) {
          setItems(response.data.data);
        } else {
          console.error("Error fetching countries:", response.data.message);
        }
      }
    } catch (error) {
      if (error?.response?.data?.error_code === 1001) {
        navigate("/permission-denied");
      } else {
        console.error("Error fetching countries:", error);
      }
    }
  };
  
  useEffect(() =>{
    fetchTimezoneOptions();
  },[])

const handleCountryClick = (countryId) => {
  navigate('/states', { state: { countryId } });
};

  useEffect(() => {
    fetchCountries();
    setFilters(pageKey, {
      searchParams,
      selectedFilterOption,
      selectedSortOption,
  });
  }, [searchParams, selectedSortOption, selectedFilterOption]);

  useEffect(() => {
    fetchCountries();
  }, [refreshKey]);

  const fetchPlanDetails = async (planId) => {
    try {
      const response = await authenticatedAxios.get(`${baseurl}plans/?id=${planId}`);
      if (response && response.data.response_code === 1) {
        setSelectedPlan(response.data.data);
        setIsDetailPopupOpen(true);
      } else {
        console.error("Error fetching plan details");
      }
    } catch (error) {
      console.error("Error fetching plan details:", error);
    }
  };


  const fetchAllActivePlans = async () => {
    try {
      const response = await authenticatedAxios.get(`${baseurl}plans/active/`);
      if (response.data.response_code === 1) {
        setPlans(response.data.data);
        setActivePlanOptions(
          response.data.data.map((plan) => ({
            label: plan.plan_name,
            value: plan.id,
          }))
        );
      } else {
        console.error("Error fetching active plans:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching active plans:", error);
    }
  };


  const fetchCurrencyOptions = async () => {
    try {
      const response = await authenticatedAxios.get(`${baseurl}currency/active/`);
      if (response.data.response_code === 1) {
        const options = response.data.data.map(currency => ({
          label: currency.name,
          value: currency.id
        }));
        setCurrencyOptions(options);
        
      } else {
        console.error('Error fetching currencies:', response.data.message);
      }
    } catch (error) {
      console.error('Error fetching currencies:', error);
    }
  };

  const fetchTimezoneOptions = async () => {
    try {
      const { data } = await authenticatedAxios.get(`${baseurl}localization/timezones/`);
      if (data.response_code === 1) {
        setTimezoneOptions(
          data.data.map(({ name, timezone, id }) => ({
            label: `${name} ${timezone}`,
            value: id
          }))
        );
      } else {
        console.error('Error fetching currencies:', data.message);
      }
    } catch (err) {
      console.error('Error fetching currencies:', err);
    }
  };


// const handleAddCountry = async (formValues) => {
//   console.log(formValues)
//   const formData = new FormData();
  
//   Object.keys(formValues).forEach(key => {
//     if (key !== 'plans') {
//       formData.append(key, formValues[key]);
//     }
//   });
  
//   formValues.plans.forEach(plan => {
//     formData.append('plans', plan.value); 
//   });

//   try {
//     const response = await authenticatedAxios.post(
//       `${baseurl}localization/country/`,
//       formData
//     );
    
//     if (response.data.response_code === 1) {
//       await fetchCountries();
//       closePopups();
//     } else {
//       setPopupError(response.data.message || 'Something went wrong!');
//     }
//   } catch (error) {
//     setPopupError('Failed to add country. Please try again.');
//   }
// };

  const handleAddCountry = async (formValues) => {
    console.log(formValues);
    const formData = new FormData();
    
    Object.keys(formValues).forEach(key => {
      if (key !== 'plans' && key !== 'timezone') {
        formData.append(key, formValues[key]);
      }
    });
    
    // Handle plans
    if (formValues.plans && Array.isArray(formValues.plans)) {
      formValues.plans.forEach(plan => {
        formData.append('plans', plan.value || plan.id); 
      });
    }

    // Handle multiple timezones
    if (formValues.timezone && Array.isArray(formValues.timezone)) {
      formValues.timezone.forEach(timezone => {
        formData.append('timezones', timezone.value || timezone.id);
      });
    }

    try {
      const response = await authenticatedAxios.post(
        `${baseurl}localization/country/`,
        formData
      );
      
      if (response.data.response_code === 1) {
        await fetchCountries();
        closePopups();
      } else {
        setPopupError(response.data.message || 'Something went wrong!');
      }
    } catch (error) {
      setPopupError('Failed to add country. Please try again.');
    }
  };


  const EditCountry = async (formValues) => {
    const formData = new FormData();

    Object.keys(formValues).forEach(key => {
      if (key !== 'plans' && key !== 'timezone' && formValues[key]) {
        formData.append(key, formValues[key]);
      }
    });

    // Handle plans
    if (formValues.plans && Array.isArray(formValues.plans)) {
      formValues.plans.forEach(plan => {
        formData.append('plans', plan.value || plan.id);
      });
    }

    // Handle multiple timezones
    if (formValues.timezone && Array.isArray(formValues.timezone)) {
      formValues.timezone.forEach(timezone => {
        formData.append('timezones', timezone.value || timezone.id);
      });
    }

    try {
      const response = await authenticatedAxios.put(
        `${baseurl}localization/country/?id=${selectedItem.id}`,
        formData
      );

      if (response.data.response_code === 1) {
        await fetchCountries();
        closePopups();
      } else {
        setPopupError(response.data.message || 'Something went wrong!');
      }
    } catch (error) {
      setPopupError('Failed to edit country. Please try again.');
    }
  };

const handleDelete = async () => {
  try {
    const response = await authenticatedAxios.delete(
      `${baseurl}localization/country/?id=${selectedItem.id}`
    );

    if (response.status >= 200 && response.status < 300) {
      setIsDeletePopupOpen(false); 
      fetchCountries(); 
      return;
    }
    throw new Error(`Unexpected status code: ${response.status}`);
  } catch (error) {
    // console.error('Error deleting plan:', error);
  }
};

const handleArchiveSelectedItems = async () => {
  try {
    const response = await authenticatedAxios.post(`${baseurl}localization/country/archive/`, {
      id_list: selectedItems,
    });

    if (response.status >= 200 && response.status < 300) {
      fetchCountries();
      resetCheckboxState(); 
      setIsArchivePopupOpen(false);
    } else {
      console.error('Failed to archive/unarchive selected items.');
    }
  } catch (error) {
    console.error('Error archiving/unarchiving selected items:', error);
  }
};


const handleArchive = async () => {
  try {
    const response = await authenticatedAxios.get(
      `${baseurl}localization/country/archive/?id=${selectedItem.id}`
    );

    if (response.status >= 200 && response.status < 300) {
      await fetchCountries();
      closePopups();
    }

    // If needed later, handle non-2xx responses here
  } catch (error) {
    // Intentionally ignoring errors for now
  }
};



  const mapSortOptionToQuery = (option) => {
    switch (option) {
      case 'A-Z':
        return 'a_to_z';
      case 'Z-A':
        return 'z_to_a';
      case 'Newest':
        return 'newest';
      case 'Oldest':
        return 'oldest';
      default:
        return 'newest';
    }
  };

  
  const handleSearchSelect = (searchTerm) => {
    setSearchParams({ term: searchTerm });
  };

 
  const handleSortOptionSelect = (option) => {
    setSelectedSortOption(option);
  };

  const handleFilterSelect = (option) => {
    setSelectedFilterOption(option);
};

  // Edit and archive functionality
  const handleEditClick = (item) => {
    fetchCountries(item.id)
    fetchCurrencyOptions();
    fetchAllActivePlans();
  };

  const handleDeleteClick = async (item) => {
    setSelectedItem(item);
    setIsDeletePopupOpen(true);
  };

  const handleArchiveClick = async (item) => {
    setSelectedItem(item);
    setIsArchivePopupOpen(true);
  };


  // Open/Close popups
  const handleNewClick = () => {
    setSelectedItem(null);
    setIsNewPopupOpen(true);
    fetchCurrencyOptions();
    fetchAllActivePlans();

  };

  const closePopups = () => {
    setIsEditPopupOpen(false);
    setIsArchivePopupOpen(false);
    setIsNewPopupOpen(false);
    setIsDetailPopupOpen(false);
    setSelectedItem(null);
    setSelectedPlan(null);
    setPopupError('');
  };

  const addPopupFields = [
    {
      label: 'Country Name',
      name: 'name',
      type: 'large-input',
      validators: [isRequired, isTextOnly]
    },
    {
      label: 'ISO Code',
      name: 'iso_code',
      type: 'large-input',
      validators: [isRequired]
    },
    {
      label: 'Country Code',
      name: 'country_code',
      type: 'large-input',
      validators: [isRequired, isValidCountryCode]
    },
    {
      label: 'Currency',
      name:  'currency',
      type: 'large-select',
      options: currencyOptions,
      defaultValue: '',
      validators: [isRequired]
    },

    {
      label: 'Upload Flag',
      name: 'country_flag',
      type: 'upload-box-country',
      onFileChange: (file) => console.log('Selected file:', file), // Handle the file selection
      validators: [isRequired]
      
    },
    
    {
      label: 'Plans',
      name: 'plans',
      type: 'search-select', 
      options: activePlanOptions,
      validators: [isRequired],
      defaultValue: [] ,
     
    },

    {
      label: 'Timezones',
      name: 'timezone',
      type: 'search-select-timezone', 
      options: timezoneOptions, // This should have the timezone data
      allTimezones: timezoneOptions, // Add this explicit prop
      validators: [isRequired],
      defaultValue: []
    }
  ];

  const editPopupFields = [
    { label: 'Country Name', name:'name', type: 'large-input',validators: [isRequired, isTextOnly], defaultValue: selectedItem?.name || ''  },
    { label: 'ISO Code', name: 'iso_code', type: 'large-input',validators: [isRequired], defaultValue: selectedItem?.iso_code || '' },
    { label: 'Country Code', name: 'country_code', type: 'large-input',validators: [isRequired, isValidCountryCode], defaultValue: selectedItem?.country_code || '' },
    { 
      label: 'Currency', 
      type: 'large-select', 
      name: 'currency',
      options: currencyOptions,
      defaultValue: selectedItem?.currency?.id,
    },

    {
      label: 'Upload Flag',
      name: 'country_flag', 
      type: 'edit-upload-box-country',
      existingImage: selectedItem ? `${baseurl.replace(/\/$/, '')}${selectedItem.country_flag}` : null,

    },
    {
      label: 'Plans',
      name: 'plans',
      type: 'search-select', 
      options: activePlanOptions,
      defaultValue: selectedItem?.plans.map(plan => ({ id: plan.id, label: plan.plan_name || plan.display_name })),
      validators: [isRequired],
    },
{
  label: 'Timezones',
  name: 'timezone',
  type: 'search-select-timezone',
  options: timezoneOptions,
  allTimezones: timezoneOptions,
  defaultValue: selectedItem?.timezones.map(timezone => ({
    id: timezone.id,
    value: timezone.id,
    label: `${timezone.name} (${timezone.timezone})`
  })) || [],
  validators: [isRequired],
}


    
  ];

  const deletePopupFields = [
    { label: 'Are you sure you want to delete this record? Once deleted, it cannot be recovered.', type: 'text' },
  ];

  const detailPopupFields = selectedPlan
  ? [
      { label: "Plan Name", type: "large", value: selectedPlan.plan_name || "N/A" },
      { label: "Display Name", type: "small", value: selectedPlan.display_name || "N/A" },
      { label: "Trial Period (Days)", type: "small", value: selectedPlan.trial_period || "N/A" },
      { label: "Monthly Price", type: "small", value: `${selectedPlan.currency?.symbol || ""} ${selectedPlan.monthly_price || "N/A"}` },
      { label: "Yearly Price", type: "small", value: `${selectedPlan.currency?.symbol || ""} ${selectedPlan.yearly_price || "N/A"}` },
      {
        label: "Features",
        type: "features-list",
        value: selectedPlan.features?.map((feature) => ({
          label: feature.name,
          id: feature.id,
        })) || [],
      },
    ]
  : [];

const handleDetailClick = (planId) => {
  fetchPlanDetails(planId);
};


const handleExportComplete = () => {
  resetCheckboxState();
};

useEffect(() =>{
  console.log(activePlanOptions)
},[activePlanOptions])

  return (
    <div className='whole-container'>
      <div className='top-heading'>
      <PageHeader pageName=" Localization /" nestedpageName="Countries"  linkTo="" /> 
        <div className='export-container'>
          <ArchiveSelectedItem
            selectedItems={selectedItems}
            items={items}
            onArchiveSelected={handleArchiveSelectedItems} 
          />
          <ExportLabel
            exportUrl={`${baseurl}localization/country/export/`}
            selectedIds={selectedItems}
            onExportComplete={handleExportComplete}
          />

        </div>
      </div>
      <div className='pagename-container'>
        <div className='page-name'>
          <h1 className='common-text fts-22 ftw-6 blue'>Countries</h1>
        </div>
        <div className='pagename-right-container'>
          <AddButton onClick={handleNewClick} />
          <SimpleSearchBox placeholder="Search Country" onSearchSelect={handleSearchSelect} defaultValue={searchParams?.term}/>
          <Filter options={filterOptions} onFilterSelect={handleFilterSelect} defaultValue={selectedFilterOption}/>
          <Sort options={sortOptions} onOptionSelect={handleSortOptionSelect} defaultValue={selectedSortOption}/>
        </div>
      </div>
      <div className='table-container'>
        <table className='common-table'>
          <thead className='common-table-head'>
            <tr className='common-table-thead-tr'>
              <th>
                  <input
                    className="table-selectbox table-parent-selectbox"
                    type="checkbox"
                    checked={isParentSelected}
                    onChange={handleParentCheckboxChange}
                  />COUNTRY
              </th>
              <th>ISO 3166 CODE</th>
              <th>CURRENCY</th>
              <th>Timezone</th>
              <th>ACTIVE PLANS</th>
              <th className='for-hide'>Actions</th>
            </tr>
          </thead>
          <tbody className='common-table-tbody'>
            {items.length > 0 ? (
              items.map(country => (
                <tr key={country.id} className={country.is_archived ? 'archived-item' : ''}>

                  <td  className='country-label'>
                    <input
                      className="table-selectbox table-child-selectbox"
                      type="checkbox"
                      checked={selectedItems.includes(country.id)}
                      onChange={() => handleChildCheckboxChange(country.id)}
                    />
                    <img 
                      onClick={() => handleCountryClick(country.id)} 
                      src={`${baseurl.replace(/\/$/, '')}${country.country_flag}`} 
                      alt={`${country.name} icon`} 
                      className="country-icon" 
                    />

                    <span onClick={() => handleCountryClick(country.id)} className='blue cr-pointer'>{country.name}</span>
                  </td>
                  <td>{country?.iso_code}</td>
                  <td>
                    {country?.currency?.name}
                    {country?.currency?.symbol ? ` (${country.currency.symbol})` : ''}
                  </td>

                  <td>
  {Array.isArray(country.timezones) && country.timezones.length > 0 ? (
    <>
      {country.timezones.slice(0, 1).map((tzObj, index) => (
        <span key={tzObj.id || index}>
          {tzObj.name} ({tzObj.timezone})
          {index < Math.min(1, country.timezones.length - 1) && ', '}
        </span>
      ))}

      {country.timezones.length > 2 && (
        <span className="ml-1 blue">+{country.timezones.length - 1} more</span>
      )}
    </>
  ) : (
    '—'
  )}
</td>




                  <td className="blue cr-pointer">
                    <span className="plan-name">
                      {country.plans.map((plan, index) => (
                        <span key={plan.id} className="plan-name" onClick={() => handleDetailClick(plan.id)}>
                          {plan?.display_name}
                          {index < country.plans.length - 1 && <span className="slash lt-gray fts-20"> | </span>}
                        </span>
                      ))}
                    </span>
                  </td>


                  <td className="actions common-action">
                    <EditIcon onClick={() => handleEditClick(country)} />
                    <ArchiveIcon onClick={() => handleArchiveClick(country)} isArchived={country.is_archived}/>
                    <DeleteIcon onClick={() => handleDeleteClick(country)} />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No countries available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <EditPopup
        isOpen={isEditPopupOpen}
        title="Edit Country"
        fields={editPopupFields}
        onSave={EditCountry}
        onClose={closePopups}
        popupErrorMessage={popupError}
      />

      <ArchivePopup
        isOpen={isArchivePopupOpen}
        isArchived={selectedItem?.is_archived }
        archivename={selectedItem?.name }
        onSave={handleArchive}
        onClose={() => setIsArchivePopupOpen(false)}
      />      

      <AddPopup
        isOpen={isNewPopupOpen}
        title="New Country"
        buttonName='Add Country'
        fields={addPopupFields}
        onSave={handleAddCountry}
        onClose={closePopups}
        popupErrorMessage={popupError}
      />
      <DetailPopup isOpen={isDetailPopupOpen} title="Plan Details" details={detailPopupFields} onClose={closePopups} />

      <DeletePopup
        isOpen={isDeletePopupOpen}
        title="Delete Country"
        fields={deletePopupFields}
        onSave={handleDelete}
        onClose={closePopups}
      /> 
    </div>
  );
};

export default Countries;
